/**
 * Finds <img> tags, adds lazyload class and swaps attributes
 * for lazyloading with lazysizes npm package
 *
 * @param {String} content  Stringified html containing <img> tags
 * @return {String}
 */
function updateImagesForLazyloading(content) {
  const imgElements = content.match(/<img.*?src="(.*?)"[^>]*>/g);
  if (null === imgElements) {
    return content;
  }

  const imgElementsModified = [];
  let updatedContent = content;

  imgElements.forEach((imgElement) => {
    const imgElementWithLazyloadClass = imgElement.replace(/class="(.*?([^"]+))/g, (classes) => `${classes} lazyload`);
    const attributesToReplace = {
      src: 'data-src', // 'srcset' attribute will also be replaced with 'data-srcset' as it has the same 'src' root
      sizes: 'data-sizes',
    };
    const imgElementWithReplacedAttributes = imgElementWithLazyloadClass.replace(/src|sizes/gi,
      (matched) => attributesToReplace[matched]);
    imgElementsModified.push(imgElementWithReplacedAttributes);
  });

  imgElements.forEach((imgElement, index) => {
    updatedContent = updatedContent.replace(imgElement, imgElementsModified[index]);
  });

  return updatedContent;
}

export default updateImagesForLazyloading;
